import React from 'react';
import ReSelect from 'react-select';
import {useTranslation} from 'react-i18next';
import MultiSelectOption from '../../../components/elements/question/multiselect/MultiSelectOption';

export type Option = {
    value: string;
    label: string;
};

interface MultiSelectProps {
    options: Option[];
    value?: Option[];
    onChange: (e: Option[] | null) => void;
    onBlur?: () => void;
    disabled?: boolean;
    placeholder?: string;
    menuPositionOverridden?: boolean;
    onMenuScrollToBottom?: () => void;
}

export function MultiSelect(props: MultiSelectProps): JSX.Element {
    const {options, value, onChange, onBlur, disabled = false, menuPositionOverridden = false, onMenuScrollToBottom, placeholder} = props;

    const {t} = useTranslation();

    return (
        <>
            <ReSelect
                isDisabled={disabled}
                placeholder={placeholder || t('presEditPage.editSidebar.elements.selectPlaceholder')}
                options={options}
                value={value}
                onChange={(e) => {
                    onChange(e as unknown as Option[] | null);
                }}
                isMulti
                hideSelectedOptions={false}
                closeMenuOnSelect={false}
                openMenuOnFocus={menuPositionOverridden}
                components={{
                    Option: MultiSelectOption,
                }}
                menuShouldScrollIntoView={false}
                onBlur={() => onBlur && onBlur()}
                onMenuScrollToBottom={onMenuScrollToBottom}
                styles={{
                    indicatorSeparator: () => ({display: 'none'}),
                    indicatorsContainer: (base) => ({...base, display: 'none', padding: '.5em'}),
                    dropdownIndicator: (base) => ({...base, padding: '.5em'}),
                    valueContainer: (base) => ({
                        ...base,
                        padding: '0.125em 2.875em 0.125em .5em',
                        flexWrap: 'nowrap',
                        outline: 'none',
                        border: 'none',
                    }),
                    placeholder: (base) => ({...base, margin: '0 0.125em', fontSize: '0.875em', color: '#545454'}),
                    input: (base) => ({
                        ...base,
                        padding: '0.125em 0',
                        margin: '0.125em',
                    }),
                    control: (base) => ({
                        ...base,
                        fontSize: 'inherit',
                        borderRadius: '0.625em',
                        borderWidth: '0.0625em',
                        minHeight: '2.375em',
                        cursor: 'pointer',
                        border: 'none',
                        backgroundColor: '#4949491A',
                    }),
                    menu: (base) =>
                        menuPositionOverridden
                            ? {
                                  ...base,
                                  position: 'relative',
                              }
                            : base,
                    option: (base) => ({
                        ...base,
                        fontSize: '0.875em',
                        padding: '.5em .75em',
                        backgroundColor: 'white',
                        color: '#676666',
                        cursor: 'pointer',
                    }),
                    container: (base) => ({...base, width: '100%'}),
                    multiValueRemove: () => ({paddingRight: '0.1875em', display: 'flex', alignSelf: 'center'}),
                    multiValueLabel: (base) => ({...base, padding: '0.1875em 0.375em '}),
                    multiValue: (base) => ({
                        ...base,
                        backgroundColor: '#ffffff',
                        border: '1px solid #d2d2d2',
                        width: 'fit-content',
                        borderRadius: '0.25rem',
                    }),
                }}
            />
        </>
    );
}
